  /**
   * @memberof SMART2
   * @ngdoc directive
   * @name Sub-section
   * @description This directive is useful for creating subsection with custom behaviour.
   * 
   * @attr {Var} ng-model
   *    Data to be passed to subsection controller. ngModel can be accessed as $scope.ngModel.data. Any modifications done on $scope.ngModel.data will reflect in actual data model.
   * @attr {String} template-url
   *    Template to be rendered inside subsection ui element
   * @attr {Number} colspan
   *    Number of columns to be occupied by this ui element. 1 column is equal to 1 ui element.
   *    Default value is 1.
   *    For e.g. If colspan is set to 2, this ui element will occupy width of 2 ui elements (fields).
   * @attr {Function} on-load
   *    Callback function when subsection is rendered. This is expected to be subsection controller function and parameters which are passed are expected to be form-widget controllers variables.
   * 
   * @example
   Dynamic:
   Controller:
       $scope.config = {
            "modelData": {
                "location": {
                    "address1": "Building no. 3, Mindspace IT park",
                    "address2": "Airoli",
                    "city": "Navi Mumbai",
                    "state": "MH",
                    "country": "India"
                }
            },
            "formConfig": {
                "sections": [
                    {
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "",
                                        "type": "subsection",
                                        "isMandatory": true,
                                        "data": "location",
                                        "templateUrl": "abc.html",
                                        "colspan": 1
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>
    
   * @example
    Static:
    Controller:
        $scope.location = { "address1": "Building no. 3, Mindspace IT park", "address2": "Airoli", "city": "Navi Mumbai", "state": "MH", "country": "India" };
       
    Usage:
        <smart-subsection template-url="abc.html" ng-model="location"></smart-subsection> 
   */

(function() {
    'use strict';
    var subsectionId = 0;
    
    angular.module('SMART2').directive('smartSubsection', ['$compile', 'ScrollTo', function ($compile, ScrollTo) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                modelData: '=?',
                templateUrl: '@',
                controller: '@',
                isMandatory: '@',
                isVisible: '=',
                focus: '=?',
                parentElement: '@',
                parentScope: '=?',
                removable: '@',
                formModel: '=?',
				init: '@'
            },
            link: function (scope, element, attrs) {
                scope.onLoad = attrs.onLoad;

                subsectionId = subsectionId + 1;
                scope.subsectionId = 'subsection-' + subsectionId;

                scope.ngModel = {
                    data: scope.modelData
                };

                /*
                 *  Listen the changes on model data and update sub-section data
                 */
                var onModelData = scope.$watch('modelData', function (newVal) {
                    scope.ngModel = {
                        data: newVal
                    };
                }, true);

                /*
                 *  Listen the changes send it to parent scope
                 */
                var onNgModelData = scope.$watch('ngModel.data', function (newVal) {
                    scope.modelData = newVal;
                }, true);

                /*
                 * Focus the textfield as soon as the focus is set to true
                 */
                var onFocus = scope.$watch('focus', function (newVal, oldVal) {
                    if (newVal) {
                        ScrollTo.perform(element, angular.element('#' + scope.parentElement));
                        scope.focus = false;
                    }
                });

                scope.isRemovable = scope.$eval(scope.removable) == undefined ? true : scope.$eval(scope.removable);

                if (scope.controller == '') {
                    element.html('<div ng-class="{\'optionalField\': isMandatory == \'false\' && isRemovable}"><div class="optionalFieldHover highlight" ng-if="isMandatory == \'false\' && isRemovable" ng-include="\'shared/directives/uiElements/commonTemplates/optionalFieldRemoveButton.html\'"></div><div ng-include="templateUrl" on-subsection-load></div></div>');
                }
                else {
                	element.html('<div ng-class="{\'optionalField\': isMandatory == \'false\' && isRemovable}"><div class="optionalFieldHover highlight" ng-if="isMandatory == \'false\' && isRemovable" ng-include="\'shared/directives/uiElements/commonTemplates/optionalFieldRemoveButton.html\'"></div><div ng-controller="' + scope.controller + '" ng-init="' + scope.init + '" ng-include="templateUrl" on-subsection-load></div></div>');
                }
                $compile(element.contents())(scope);

                scope.$on('$destroy', function () {
                    onModelData();
                    onNgModelData();
                    onFocus();
                });
            }
        };
    }]);


    angular.module('SMART2').directive('onSubsectionLoad', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (angular.isDefined(scope.onLoad)) {
                    scope.$eval(scope.onLoad);
                }
            }
        };
    }]);
})();    